import { FieldSize } from './Field.types';
import { TypoVariant } from '@/components';

export const LABEL_VARIANT_BY_SIZE = {
  [FieldSize.S]: TypoVariant.CaptionSRegular,
  [FieldSize.M]: TypoVariant.BodyXSRegular,
  [FieldSize.L]: TypoVariant.BodyXSRegular,
  [FieldSize.XL]: TypoVariant.BodyMRegular,
};

export const INNER_TEXT_VARIANT_BY_SIZE = {
  [FieldSize.S]: TypoVariant.BodyMRegular,
  [FieldSize.M]: TypoVariant.BodyMRegular,
  [FieldSize.L]: TypoVariant.BodyLRegular,
  [FieldSize.XL]: TypoVariant.BodyXLRegular,
};
